module.exports = __webpack_public_path__ + "img/szzljy.9ed481c7.jpg";